module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.9f01df3b0b712f4ec5c5.js");
};